<template>
<div  class="container">
  <a-form-model :model="form" class="form-container" >
    <a-form-model-item>
      <a-input
        style="height: 44px"
        v-model="form.phone"
        placeholder="请输入注册手机号" @keyup.enter="login"
        @focus="handleIcon('phone_icon')"
        @blur="blurIcon('phone_icon')"
      >
        <eco-icon
          slot="prefix"
          name="phone1"
          :color="phone_icon ? '#4771F8' : '#777777'"
          size="16"
        ></eco-icon>
      </a-input>
    </a-form-model-item>
    <a-form-model-item>
      <a-input
        style="height: 44px"
        v-model="form.code"
        placeholder="请输入验证码" @keyup.enter="login"
        @focus="handleIcon('number_icon')"
        @blur="blurIcon('number_icon')"
      >
        <eco-icon
          slot="prefix"
          name="number"
          :color="number_icon ? '#4771F8' : '#777777'"
          size="16"
        ></eco-icon>
      </a-input>
      <a-button
        type="link"
        class="code-btn"
        @click="sendCode"
        :disabled="this.wait.count !== 0"
        >{{ btnText }}</a-button
      >
    </a-form-model-item>

    <div>
      <a-button class="login-btn" type="primary" @click="login">注销账号</a-button>
    </div>
  </a-form-model></div>
</template>

<script>
import { sendPhoneCode, phoneLogin } from "@/request/delete";

export default {
  data: () => ({
    form: { phone: "", code: "" },
    wait: { count: 0, isSend: false },
    phone_icon: false,
    number_icon: false,
  }),
  computed: {
    btnText() {
      if (!this.wait.isSend) return "获取验证码";
      if (this.wait.count === 0) return "重新发送";
      return `已发送（${this.wait.count}）`;
    },
  },
  methods: {
    // 处理icon
    handleIcon(icon) {
      if (icon === "number_icon") {
        this.number_icon = true;
      }
      if (icon === "phone_icon") {
        this.phone_icon = true;
      }
    },
    blurIcon(icon) {
      if (icon === "number_icon") {
        this.number_icon = false;
      }
      if (icon === "phone_icon") {
        this.phone_icon = false;
      }
    },
    sendCode() {
      if (!this.form.phone) {
        this.$message.warn("请输入手机号！");
      } else {
        sendPhoneCode(this.form.phone)
          .then(() => {
            this.wait.count = 60;
            this.wait.isSend = true;
            this.$message.success("发送成功！");
            this.beginWait();
          })
          .catch((res) => {
            this.$message.error(res.message);
          });
      }
    },
    beginWait() {
      setTimeout(() => {
        if (this.wait.count === 0) return;
        this.wait.count = this.wait.count - 1;
        this.beginWait();
      }, 1000);
    },
    login() {
      if (!this.form.phone) {
        return this.$message.warn("请输入手机号！");
      }

      if (!this.form.code) {
        return this.$message.warn("请输入验证码！");
      }

      this.$confirm({
        title: '注销账号后，会删除涉及到该账号的一切信息且无法找回',
        content: '确定要注销该账号吗？',
        okText: '确认',
        cancelText: '取消',
        onOk:()=>{
          phoneLogin(this.form.phone, this.form.code)
            .then(() => {
              this.$emit("login");
            })
          }
      });
    },
  },
};
</script>
<style scoped lang="scss">

.container{
  background:#fff;min-height:100%;display:flex;justify-content: center; align-items: center;
  .form-container{
    width: 400px;
  }
}

.form-container ::v-deep .ant-input {
  height: 44px !important;
  &::placeholder {
    color: #777777;
  }
}
.form-container ::v-deep .ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 36px !important;
  background: inherit;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom-color: #000000;
  border-radius: 0;
  color: #777777;
  font-size: 16px;
}
.form-container ::v-deep .ant-input:focus {
  box-shadow: none;
  border-bottom-color: #4771f8 !important;
}
.code-btn {
  float: right;
  margin-top: -28px;
  color: #4771f8;
  line-height: 6px;
  height: 14px;
  font-size: 16px;
}
.form-container ::v-deep .login-btn {
  width: 100%;
  text-align: center;
  height: 44px;
  margin-top: 16px;
  background-color: red;
}

.form-container ::v-deep .ant-btn-disabled,
.ant-btn.disabled,
.ant-btn[disabled],
.ant-btn-disabled:hover,
.ant-btn.disabled:hover,
.ant-btn[disabled]:hover,
.ant-btn-disabled:focus,
.ant-btn.disabled:focus,
.ant-btn[disabled]:focus,
.ant-btn-disabled:active,
.ant-btn.disabled:active,
.ant-btn[disabled]:active,
.ant-btn-disabled.active,
.ant-btn.disabled.active,
.ant-btn[disabled].active {
  background: transparent !important;
}
</style>
